import { render, staticRenderFns } from "./channelorderreport-add-or-update.vue?vue&type=template&id=83f7c3fc&"
import script from "./channelorderreport-add-or-update.vue?vue&type=script&lang=js&"
export * from "./channelorderreport-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports